import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from 'moment';
import { saveAs } from 'file-saver';
import LoyaltyService from "modules/loyalty/services/loyaltyService";

export default function ExportTheLuckyDrawCoupons() {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      rewardType: "static_coupon",
      fromDate: moment(),
      toDate: moment(),
    },
    mode: "onChange",
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleExportTheLuckyDraw = (data: any) => {
    setIsLoading(true);
    LoyaltyService.exportLuckyDrawCoupons(data)
      .then((response: any) => {
        const file = new Blob([response], { type: 'text/csv;charset=utf-8' });
        const filename = `lucky_draw_coupons_from_${moment(data?.fromDate).format("YYYY/MM/DD")}_to_${moment(data?.toDate).format("YYYY/MM/DD")}.csv`;

        saveAs(file, filename);
        setIsLoading(false);
      })
      .catch(error => {
        console.error(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <form className="frm" onSubmit={handleSubmit(handleExportTheLuckyDraw)} noValidate>
        <Grid container spacing={2}>
          <Grid xs={12} md={4}>
            <Controller
              name="rewardType"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth>
                  <InputLabel id="reward-type-label">Reward Type</InputLabel>
                  <Select
                    {...field}
                    labelId="reward-type-label"
                    label="Reward Type"
                  >
                    <MenuItem value="static_coupon">Static coupon</MenuItem>
                    <MenuItem value="dynamic_coupon">Dynamic coupon</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          <Grid xs={12} md={4}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Controller
                control={control}
                name="fromDate"
                render={({ field, fieldState }) => (
                  <DatePicker
                    {...field}
                    label="From Date"
                    componentsProps={{
                      textField: {
                        fullWidth: true,
                        variant: 'outlined',
                        error: !!fieldState.error,
                        helperText: fieldState.error?.message
                      }
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid xs={12} md={4}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Controller
                control={control}
                name="toDate"
                render={({ field, fieldState }) => (
                  <DatePicker
                    {...field}
                    label="To Date"
                    componentsProps={{
                      textField: {
                        fullWidth: true,
                        variant: 'outlined',
                        error: !!fieldState.error,
                        helperText: fieldState.error?.message
                      }
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid xs={12}>
            <Button variant="contained" color="primary" type="submit" disabled={isLoading}>
              Export
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
